import React, { useContext, useRef, useState, useEffect } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';
import ReactModal from 'react-modal-resizable-draggable';
import classNames from 'classnames';
import useAccessibilityClick from '../../../hooks/useAccessibilityClick';
import '../../../css/Tools.scss';
import '../../../css/Accessibility.scss';
import useReactModalResizeableDraggable from '../../../hooks/useReactModalResizeableDraggable';
import DialogPositionService from '../../services/DialogPositionService';
import { register } from '../../../i18n';

const t = register('ToolNames');

const TextHelpCustom = observer(() => {
// function TextHelpCustom() {

  const {
    toolbarManager
  } = useContext(MobXProviderContext);

  const [isSpeaking, setIsSpeaking] = useState(toolbarManager.textHelpApi.speechTools.isSpeaking());
  const [isClickToSpeakOn, setIsClickToSpeakOn] = useState(toolbarManager.textHelpApi.speechTools.getClickToSpeakState());

  // Announce when TextHelp dialog opens
  useEffect(() => {
    const announcementElement = document.getElementById('texthelp-dialog-announcement');
    if (announcementElement) {
      announcementElement.textContent = `Text Help dialog opened`;
    }
  }, []);

  const stopRef = useRef();
  const playRef = useRef();
  const pauseRef = useRef();
  const clickToSpeakRef = useRef();
  const startLeft = (window.innerWidth - 275);

  useAccessibilityClick(stopRef, (e) => {
    toolbarManager.textHelpApi.speechTools.stop();
    setSpeechToolStates();
  });

  useAccessibilityClick(playRef, (e) => {
    // if click to speak is on, shut it off before playing.
    const clickToSpeakState = toolbarManager.textHelpApi.speechTools.getClickToSpeakState();
    if (clickToSpeakState) {
      toolbarManager.textHelpApi.speechTools.clickToSpeak();
    }
    toolbarManager.textHelpApi.speechTools.play();
    toolbarManager.addContentToolUsage('TextHelp');
    setSpeechToolStates();
  });

  useAccessibilityClick(pauseRef, (e) => {
    toolbarManager.textHelpApi.speechTools.pause();
  });

  useAccessibilityClick(clickToSpeakRef, (e) => {
    const isSpeaking = toolbarManager.textHelpApi.speechTools.isSpeaking();
    if (isSpeaking) {
      toolbarManager.textHelpApi.speechTools.stop();
    }
    toolbarManager.textHelpApi.speechTools.clickToSpeak();
    setSpeechToolStates();
  });

  function setSpeechToolStates() {
    setIsClickToSpeakOn(toolbarManager.textHelpApi.speechTools.getClickToSpeakState());
    setIsSpeaking(toolbarManager.textHelpApi.speechTools.isSpeaking());
  }

  useReactModalResizeableDraggable('textHelpCustom');

  console.info(isClickToSpeakOn);
  console.info(isSpeaking);

  return (
    <div className='textHelpCustom'>
      {/* Live region for announcements */}
      <div 
        id="texthelp-dialog-announcement" 
        className="sr-only" 
        aria-live="polite" 
        aria-atomic="true"
      />
      
      <ReactModal
        className='textHelpModal'
        disableResize={true}
        initHeight={65}
        initWidth={165}
        isOpen={true}
        left={startLeft}
        top={DialogPositionService.getDefaultTopPosition()}
        role="dialog"
        aria-labelledby="texthelp-dialog-title">
        <div className='selectorBody'>
          <h2 id="texthelp-dialog-title" className='title-label basic'>{t('textHelpTitle')}</h2>
          <div className='control-container'>
            <div className='control-section'>
              <button ref={clickToSpeakRef}
                aria-label='Click to speak'
                className={classNames({
                  clickToSpeakButton: true,
                  listenIcon: true,
                  isActive: (isClickToSpeakOn)
                })} />
              <button ref={playRef}
                aria-label='Read Screen'
                className={classNames({
                  playButton: true,
                  listenIcon: true,
                  isActive: (isSpeaking)
                })} />
              <button ref={pauseRef} aria-label='pause' className='pauseButton listenIcon' />
              <button ref={stopRef} aria-label='stop' className='stopButton listenIcon' />
            </div>
          </div>
        </div>
      </ReactModal>
    </div>
  );
});

export default TextHelpCustom;
